import { get, fileUpload } from '../axios'
import store from '@/store'

// 获取微信用户信息
const getUserInfo = (code) => {
  let params = {
    code
  }
  return get('/activity/wx/getUserInfo', params)
}

/**
 * 获取用户token
 * @returns
 */
export const getMemberByToken = () => {
  return get('/activity/member/token', { token: store.state.token })
}
// 微信分享
const getSign = (appId) => {
  const link = window.location.href.split('#')[0]
  var params = {
    url: link,
    appId
  }
  return get('/activity/wx/signature', params)
}

// 获取新闻列表
const getNewsList = (cids) => {
  return get('/foshan/api/v2/getNewsList', { specialSno: -1, cids, count: 30 })
}

/**
 * 上传文件
 * @param {*} files
 */

export const takeFileUpload = (file, config) => {
  var params = new FormData()
  params.append('file', file)
  params.append('token', store.state.token)
  return fileUpload(`/activity/file/upload`, params, config)
}

// 获取活动配置
const getActivityConfig = (code) => {
  return get('/activity/votegjierkgrjekg', { code: code })
}

export default {
  getUserInfo,
  getSign,
  getNewsList,
  takeFileUpload,
  getMemberByToken,
  getActivityConfig
}
